'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { OpenPaymentsNoticeContent } from './open-payments-notice-content.component';
import { useOpenPaymentsNotice } from './use-open-payments-notice.hook';

export function OpenPaymentsNotice() {
  const { isRendered } = useOpenPaymentsNotice('banner');

  if (!isRendered) {
    return null;
  }

  return (
    <div
      role="status"
      className="flex w-full items-start gap-3 border border-warning-300 bg-warning-100 px-6 py-3 shadow-floating"
      data-testid={DataTestIdEnum.OPEN_PAYMENTS_NOTICE}
    >
      <OpenPaymentsNoticeContent />
    </div>
  );
}
